import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';
const IconFacebook2 = t0 => {
  const $ = _c(9);
  const {
    color: t1,
    width: t2,
    height: t3,
    className: t4
  } = t0;
  const color = t1 === undefined ? colorGray : t1;
  const width = t2 === undefined ? "25" : t2;
  const height = t3 === undefined ? "24" : t3;
  const className = t4 === undefined ? "" : t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <defs><polygon points="0.3562 0 24.356 0 24.356 24 0.3562 24" /></defs>;
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  let t6;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <g />;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== color) {
    t7 = <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g>{t6}<path d="M23.0322,0 L1.6792,0 C0.9492,0 0.3562,0.593 0.3562,1.324 L0.3562,22.676 C0.3562,23.408 0.9492,24 1.6792,24 L13.1742,24 L13.1742,14.706 L10.0452,14.706 L10.0452,11.085 L13.1742,11.085 L13.1742,8.41 C13.1742,5.311 15.0682,3.625 17.8332,3.625 C19.1582,3.625 20.2972,3.722 20.6292,3.766 L20.6292,7.006 L18.7082,7.006 C17.2082,7.006 16.9162,7.727 16.9162,8.777 L16.9162,11.088 L20.5002,11.088 L20.0352,14.718 L16.9162,14.718 L16.9162,24 L23.0312,24 C23.7632,24 24.3562,23.408 24.3562,22.676 L24.3562,1.324 C24.3562,0.593 23.7632,0 23.0322,0" fill={color} /></g></g>;
    $[2] = color;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== className || $[5] !== height || $[6] !== t7 || $[7] !== width) {
    t8 = <svg width={width} height={height} viewBox="0 0 25 24" className={className}>{t5}{t7}</svg>;
    $[4] = className;
    $[5] = height;
    $[6] = t7;
    $[7] = width;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
};
IconFacebook2.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default IconFacebook2;